// extracted by mini-css-extract-plugin
module.exports = {"button":"SearchBar_button__LVKii","input":"SearchBar_input__U6cJ3","SearchBar":"SearchBar_SearchBar__2OBC6"};